import { Box, BoxProps } from '@chakra-ui/react'

import { ThemeColor } from 'src/types'

type ExpandCollapseButtonProps = {
  expanded: boolean
  labelExpanded?: string
  labelCollapsed?: string
  textColor?: ThemeColor
  className?: 'body-regular' | 'body-small' | 'body-extra-small'
  click?(): void
} & BoxProps

const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
  expanded,
  labelExpanded,
  labelCollapsed,
  className = 'body-regular',
  click,
  textColor,
  ...props
}) => {
  return (
    <Box
      as="span"
      cursor="pointer"
      lineHeight={1}
      bg="linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 15%)"
      p={0}
      pl={1}
      onClick={click}
      bottom={expanded ? undefined : 0}
      right={expanded ? undefined : 0}
      position={expanded ? 'relative' : 'absolute'}
      data-testid="expandableText-moreLessButton"
      {...props}
    >
      {!expanded && (
        <Box pl={1} as="span" className={className} color="stone">
          ...
        </Box>
      )}

      <Box
        ml={1}
        color={textColor}
        className={`${className}-emphasis`}
        textDecoration="underline"
        as="span"
      >
        {expanded ? labelExpanded : labelCollapsed}
      </Box>
    </Box>
  )
}

export default ExpandCollapseButton
